import { use } from 'react'
import { NotificationContext } from '../contexts'

const useNotification = () => {
  const context = use(NotificationContext)

  if (context === undefined) {
    throw new Error('useNotification must be used within a NotificationProvider')
  }

  return context
}

export { useNotification }
